// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import LandingLogo from './LandingLogo';

export default function LandingNav({ isFr, setView, toggleLanguage, scrollToSection }) {
  return (
    <header className="dbk-nav">
      <div className="dbk-nav__inner">
        <button
          type="button"
          className="dbk-nav__logo"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Digi-Bakery"
        >
          <LandingLogo />
        </button>

        <nav className="dbk-nav__links" aria-label={isFr ? 'Navigation' : 'Primary'}>
          <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>
            {isFr ? 'Fonctionnalités' : 'Features'}
          </a>
          <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }}>
            {isFr ? 'Tarif' : 'Pricing'}
          </a>
          <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>
            {isFr ? 'Questions' : 'FAQ'}
          </a>
        </nav>

        <div className="dbk-nav__actions">
          <button type="button" className="dbk-nav__lang" onClick={toggleLanguage}>
            {isFr ? 'EN' : 'FR'}
          </button>
          <button
            type="button"
            className="dbk-link dbk-nav__login"
            onClick={() => setView('login')}
          >
            {isFr ? 'Se connecter' : 'Log in'}
          </button>
          <button
            type="button"
            className="dbk-btn dbk-btn--primary dbk-btn--sm"
            onClick={() => setView('signup-baker')}
          >
            {isFr ? 'Essai gratuit' : 'Free trial'}
          </button>
        </div>
      </div>
    </header>
  );
}
